export default __webpack_public_path__ + "assets/images/7ef5452a0525898526c647ee74104ede.svg";